import { useState, useContext, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Box, Flex, Text } from 'rebass'
import { FiExternalLink } from 'react-icons/fi'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { makeDate } from '../../utils/helpers'
import { DataContext } from '../../contexts/dataContext'
import ConnectionGroup from '../molecules/ConnectionGroup'
import { lang } from '../../utils/lang'
import { getFaNum } from '../../utils/helpers'
import LrgImg from '../../assets/thumb_large.png'
import VideoFetcher from '../molecules/VideoFetcher'
import { BASE_URL } from '../../utils/constants'
import ReactTooltip from 'react-tooltip'

const Container = styled(Flex)`
  flex-direction: column;
  height: 100%;
  ${Mq.xs} {
    flex-direction: row;
  }
`

const SideBar = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  //max-height: 76vh; Turning this off for mobile. But need this if want sidebar to scroll independently on desktop.
  overflow-y: auto;
  background-color: ${(props) => props.theme.colors.ironBlue};
  padding: 3rem 2rem 1rem 1.5rem;
  ${Mq.xs} {
    width: 15rem;
    padding: 2rem 2rem 3rem 2rem;
    align-items: flex-start;
  }
`
const ImageBox = styled(Box)`
  width: 60%;
  height: 16rem;
  border: 1px solid ${(props) => props.theme.colors.white};
  margin-top: 1rem;
  margin-bottom: 0.75rem;
  img {
    border-radius: 0.25rem 0 0 0.25rem;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  ${Mq.xs} {
    width: 100%;
    height: 16rem;
    margin-top: 0.25rem;
  }
`
const PersonName = styled(Box)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1.8rem;
  font-weight: 700;
  margin-top: 1rem;
  ${Mq.xs} {
    font-size: 2rem;
    margin-top: 0;
  }
`
const UnderLine = styled(Box)`
  margin: 1rem 0 0.5rem 0;
  border-top: 1px solid ${(props) => props.theme.colors.white};
`

const Content = styled(Box)`
  flex: 1;
  padding: 0 1rem 16.5rem 1.5rem;
  overflow-y: auto;
  background-color: ${(props) => props.theme.colors.steelBlue};
  ${Mq.xs} {
    max-height: 70vh;
    padding: ${(props) =>
      props.ui === 'en' ? '1.5rem 1.5rem 0 2.5rem' : '1.5rem 2.5rem 0 2.5rem'};
  }
`
const TextContent = styled(Text)`
  font-size: 1rem;
  position: relative;
  overflow-y: ${(props) => (props.show ? 'hidden' : 'scroll')};
  height: 50vh;
  padding-top: 2rem;
  ${Mq.xs} {
    height: 50%;
    padding-top: 0;
  }
  p {
    margin: ${(props) =>
      props.ui === 'en' ? '0 1rem 1rem 0' : '0 0 1rem 1rem'};

    ${Mq.sm} {
      margin: ${(props) =>
        props.ui === 'en' ? '0 3rem 1rem 0' : '0 0 1rem 3rem'};
    }
  }
  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  // /* Track */
  // ::-webkit-scrollbar-track {
  //   background: #f1f1f1;
  // }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.aqua};
    border-radius: 50px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`
const Gradient = styled(Box)`
  background-image: linear-gradient(
    to bottom,
    transparent,
    ${(props) => props.theme.colors.steelBlue}
  );
  width: 100%;
  height: 7rem;
  position: sticky;
  bottom: -1px;
  text-align: center;
  padding-top: 3rem;
  display: ${(props) => (props.show ? 'block' : 'none')};
`
const ReadMore = styled(Text)`
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  display: ${(props) => (props.show ? 'block' : 'none')};
  cursor: pointer;
  height: 0;
`
const MediaSectionTitle = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1rem;
  font-weight: 700;
  padding-top: 1.5rem;
`
const MediaContainer = styled(Flex)`
  margin: 0 -0.5rem;
  flex-wrap: wrap;
`
// const Document = styled(Flex)`
//   position: relative;
//   width: 100%;
//   height: 172px;
//   background-color: rgba(0, 0, 0, 0.5);
//   justify-content: center;
//   align-items: center;
//   cursor: pointer;
//   margin: 0.5rem;
//   padding-bottom: 1rem;
//   ${Mq.sm} {
//     width: 45%;
//     // min-width: 300px;
//     margin: 0.5rem;
//   }
// `
const Document = styled(Flex)`
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 172px;
  background-color: rgba(0, 0, 0, 0.5);

  cursor: pointer;
  margin: 0.5rem;
  .tooltip-doc {
    width: 240px;
  }

  ${Mq.sm} {
    width: 45%;
    // min-width: 300px;
    margin: 0.5rem;
  }
`
const DocumentTitle = styled(Flex)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 2.25rem;
  background-color: ${(props) => props.theme.colors.black};
  color: ${(props) => props.theme.colors.white};
  font-size: 0.85rem;
  align-items: center;
  padding: 0 1rem;
`
const DocumentBox = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(172px - 2.25rem);
`
const DocumentImg = styled.img`
  position: absolute;
  top: 0;
  height: calc(172px - 2.25rem);
  width: 100%;
  object-fit: cover;
`
const Circle = styled(Flex)`
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.red};
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  z-index: 10;
`
const MobileBox = styled(Box)`
  ${Mq.xs} {
    display: none;
  }
`

const NonMobileBox = styled(Box)`
  display: none;
  ${Mq.xs} {
    display: block;
  }
`

const InfoItemFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding: 0.6rem 0;
  ${Mq.xs} {
    align-items: flex-start;
  }
`

const InfoItemCategory = styled(Text)`
  font-size: ${(props) => (props.ui === 'en' ? '0.75rem' : '.85rem')};
  text-transform: uppercase;
`
const InfoItemText = styled(Text)`
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  ${Mq.xs} {
    text-align: ${(props) => (props.ui === 'en' ? 'left' : 'right')};
  }
`
const InfoItem = ({ category, entry, ui, nonFatalCase, threatDates }) => {
  //nonFatalCase is only true if all violations for this person were nonFatal, ie. they weren't killed
  if (category === 'LocationKilling' && nonFatalCase) {
    category = 'LocationThreat'
  }
  let multiDates = ''
  if (category === 'DateThreat' && threatDates) {
    multiDates = threatDates
      .map((date, i) => {
        return !date || date === '0' ? lang[ui]['Unknown'] : makeDate(date, ui)
      })
      .join(', ')
  }

  return (
    <>
      {(category === 'DateThreat' && !threatDates) ||
      (category === 'DateKilling' && nonFatalCase) ? null : (
        <>
          <InfoItemFlex ui={ui}>
            <InfoItemCategory ui={ui}>{lang[ui][category]}</InfoItemCategory>
            <InfoItemText ui={ui}>
              {!entry || entry === '0'
                ? `${lang[ui]['Unknown']}`
                : category === 'DateThreat'
                ? multiDates
                : category === 'Age' && ui === 'fa'
                ? getFaNum(entry)
                : entry}
            </InfoItemText>
          </InfoItemFlex>
        </>
      )}
    </>
  )
}

const PersonRecord = ({
  newData,
  threatDates,
  personId,
  handleId,
  nonFatalCase,
  person
}) => {
  const { ui } = useContext(DataContext)
  const [show, setShow] = useState(true)
  const textRef = useRef()
  //new data
  const d = newData[personId] || newData
  //data I already have -- moved this to PersonFetcher to work better with search
  // const person = nonFatalCase
  //   ? formattedNonFatalData.find((d) => d.id === personId)
  //   : formattedData.find((d) => d.id === personId)

  // const makeDate = () => {
  //   const month =
  //     person.month && person.month !== '00' ? MONTHS[person.month] : ''
  //   const day = person.day ? ' ' + person.day : ''
  //   const punc = person.day || person.month !== '00' ? ', ' : ''
  //   return month + day + punc + person.year
  // }

  const date =
    !person.date || person.date === '0'
      ? lang[ui]['Unknown']
      : makeDate(person.date, ui)

  useEffect(() => {
    if (handleId) handleId(personId) //send person id up to modal container to render footer bar.
    //This is only defined if coming from ListModal. If coming from PersonModel, the modal already knows the id.

    //determines if content in text box is overflowing;
    //update state SHOW with results ==> which will show/hide 'read more'
    var isOverflowing = textRef.current
      ? textRef.current.clientWidth < textRef.current.scrollWidth ||
        textRef.current.clientHeight < textRef.current.scrollHeight
      : null

    if (isOverflowing) setShow(true)
    else setShow(false)
  }, [personId, handleId])

  const dir = ui === 'en' ? 'ltr' : 'rtl'
  return (
    <Container dir={dir}>
      <MobileBox>
        <ConnectionGroup
          flushLeft={ui === 'en' ? true : false}
          dir={dir}
          inModal={true}
        />
      </MobileBox>
      <SideBar>
        <MobileBox>
          <PersonName>
            {!person.fnames && !person.sname
              ? lang[ui]['UnknownPerson']
              : `${person.fnames} ${person.sname}`}
          </PersonName>
        </MobileBox>
        <ImageBox>
          <img
            src={person.photoUrlLg || LrgImg}
            alt={person.fnames + ' ' + person.sname}
          />
        </ImageBox>
        {[person.age, d.nati, d.reli, threatDates, date, person.location].map(
          (item, i) => {
            const categories = [
              'Age',
              'Nationality',
              'Religion',
              'DateThreat',
              'DateKilling',
              'LocationKilling'
            ]
            return (
              <InfoItem
                key={categories[i]}
                category={categories[i]}
                entry={item}
                ui={ui}
                //nonFatal={person.nonFatal ? true : false}
                nonFatalCase={nonFatalCase}
                threatDates={threatDates}
              />
            )
          }
        )}
      </SideBar>
      <Content ui={ui}>
        <NonMobileBox>
          <PersonName>
            {!person.fnames && !person.sname
              ? lang[ui]['UnknownPerson']
              : `${person.fnames} ${person.sname}`}
          </PersonName>
          <UnderLine />
        </NonMobileBox>
        <TextContent show={show} ui={ui} ref={textRef}>
          <div
            dangerouslySetInnerHTML={{
              __html: d.public_remarks ? d.public_remarks : lang[ui]['NoInfo']
            }}
          ></div>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
          <br />
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum. im ad minim
            veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
            ea commodo consequat. Duis aute irure dolor in reprehenderit in
            voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
            officia deserunt mollit anim id est laborum.
          </p> */}
          <Gradient show={show} />
        </TextContent>
        <ReadMore onClick={() => setShow(false)} show={show} dir={dir}>
          + {lang[ui]['Read']}
        </ReadMore>
        {(d.media_urls || d.library_items) && (
          <MediaSectionTitle>
            {lang[ui]['SupplementaryDocumentation']}
          </MediaSectionTitle>
        )}
        <MediaContainer>
          {d.media_urls?.map((url) => (
            <VideoFetcher url={url} key={url} />
          ))}
          {/* {d.media_urls?.map((url) => (
            <Document>
              <a href={`${url}`} target="_blank" rel="noreferrer">
                <img alt="vidoe" src={videoData?.thumbnail_url} />
                <Circle>
                  <FaPlay color="white" size="14" />
                </Circle>
              </a>
              <DocumentTitle></DocumentTitle>
            </Document>
          ))} */}
          {d.library_items?.map((doc) => {
            return (
              <Document key={doc.url}>
                <a
                  href={`${BASE_URL}${doc.url}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <DocumentBox>
                    {doc.thumbnail && (
                      <DocumentImg
                        alt={`${doc.title} document`}
                        src={`${BASE_URL}${doc.thumbnail}`}
                      />
                    )}
                    <Circle>
                      <FiExternalLink color="white" size="20" />
                    </Circle>
                  </DocumentBox>
                </a>
                <ReactTooltip
                  place={'top'}
                  type={'light'}
                  //arrowColor={'transparent'}
                  effect={'solid'}
                  className="tooltip-doc"
                />
                <DocumentTitle data-tip={doc.blurb}>{doc.title}</DocumentTitle>
              </Document>
            )
          })}
        </MediaContainer>
      </Content>
    </Container>
  )
}
export default PersonRecord

PersonRecord.propTypes = {
  newData: PropTypes.object.isRequired,
  personId: PropTypes.number.isRequired,
  handleId: PropTypes.func
}
